import { z } from 'zod';

const optionalIdentity = (schema: z.ZodType<string>) => z.preprocess(value => typeof value === 'string' ? value.trim() || null : value, schema.nullable().optional());
const domain = optionalIdentity(z.string().max(253).regex(/^(?=.{1,253}$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, 'Enter a hostname without scheme, port or path'));
const externalIp = optionalIdentity(z.union([z.ipv4(), z.ipv6()]));
const certificateId = optionalIdentity(z.string().min(1));

export const HostCreateInputSchema = z.object({
  name: z.string().trim().min(1).max(100),
  domain,
  externalIp,
  certificateId,
  isDefault: z.boolean().default(false)
}).superRefine((data, ctx) => {
  if (!data.domain && !data.externalIp) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Host must have a domain or external IP',
      path: ['domain']
    });
  }
});

export const HostUpdateInputSchema = z.object({
  name: z.string().trim().min(1).max(100).optional(),
  domain,
  externalIp,
  certificateId,
  isDefault: z.boolean().optional()
});

export type HostCreateInput = z.infer<typeof HostCreateInputSchema>;
export type HostUpdateInput = z.infer<typeof HostUpdateInputSchema>;
